import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import {
 
  SendOTPURL,
  VerifyOTPURL,
} from "../../assets/api/BaseURL";
import { useToast } from "../../../context/ToastContext";
// import LiveChat from "../other/LiveChat";

const LoginWithOTP = () => {
  const navigate = useNavigate();
  const { setPlan } = useToast();
  const [view, setView] = useState(null);
  const [user, setUser] = useState({ number: "", otp: "" });
  const [show, setShow] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const handleInput = (event) => {
    setUser((prev) => ({ ...prev, [event.target.name]: event.target.value }));
    setError("");
    setSuccess("");
  };

  const handleSendOTP = async (e) => {
    e.preventDefault();

    const mobileNumberPattern = /^\d{10}$/;

    if (user.number === "") {
      setError("Mobile Number cannot be empty");
      setSuccess("");
    } else if (!mobileNumberPattern.test(user.number)) {
      setError("Please enter a valid 10-digit mobile number.");
      setSuccess("");
    } else {
      try {
        const response = await axios.post(SendOTPURL, { number: user.number });

        if (response.status === 200 && response.data.message) {
          setSuccess(response.data.message);
          setShow(true);
        }
      } catch (error) {
        if (error.response && error.response.data.message) {
          setError(error.response.data.message);
          setUser({ number: "", otp: "" });
        } else {
          setError(error.message);
          setUser({ number: "", otp: "" });
        }
        console.log(error);
      }
    }
  };

  const handleVerifyOTP = async (e) => {
    e.preventDefault();

    if (user.otp === "") {
      setError("OTP cannot be empty");
    } else {
      try {
        const response = await axios.post(VerifyOTPURL, {
          number: user.number,
          otp: user.otp,
        });

        if (
          response.status === 200 &&
          response.data.token &&
          response.data.currency_symbol &&
          response.data.plan &&
          response.data.encyptedId
        ) {
          localStorage.setItem("token", response.data.token);
          localStorage.setItem("currencySymbol", response.data.currency_symbol || "");
          if (response.data.currency_code != null && response.data.currency_code !== "") {
            localStorage.setItem("currencyCode", response.data.currency_code);
          }
          localStorage.setItem(
            "planDetails",
            JSON.stringify(response.data.plan)
          );
          localStorage.setItem(
            "userId",
            JSON.stringify(response.data.encyptedId)
          );

          localStorage.setItem(
            "login_type",
            response.data.login_type
          );
      
          
          
          setPlan(response.data.plan);
          navigate("/fooders_cp");
        } else {
          setError("Internal server error");
          setUser({ ...user, otp: "" });
        }
      } catch (error) {
        if (error.response && error.response.data.message) {
          setError(error.response.data.message);
          setUser({ ...user, otp: "" });
        } else {
          setError(error.message);
          setUser({ ...user, otp: "" });
        }
        console.log(error);
      }
    }
  };

  useEffect(() => {
    if (
      localStorage.getItem("token") &&
      localStorage.getItem("planDetails") &&
      localStorage.getItem("userId") &&
      localStorage.getItem("currencySymbol")
    ) {
      navigate("/fooders_cp");
      setView(false);
    } else {
      localStorage.removeItem("token");
      localStorage.removeItem("planDetails");
      localStorage.removeItem("userId");
      localStorage.removeItem("currencySymbol");
      setView(true);
    }
  }, [navigate]);

  useEffect(() => {
    if (error || success) {
      window.scrollTo(0, 0);
    }
  }, [error, success]);

  return (
    <>
      {view && (
        <>
          <div className="container-scroller">
            <div className="container-fluid page-body-wrapper full-page-wrapper px-0">
              <div className="content-wrapper d-flex align-items-center auth px-0">
                <div className="row w-100 mx-0">
                  <div className="text-center mb-2">
                    <img
                      src="images/vyfoo_logo.png"
                      alt="logo"
                      className="loginlogo"
                    />
                  </div>
                  <div className="col-lg-4 mx-auto">
                    <div className="auth-form-light text-left py-5 px-4 px-sm-5">
                      <h4>Hello! let's get started</h4>
                      <h6 className="fw-light">Sign in to continue.</h6>
                      <form className="pt-3">
                        {error && (
                          <div className="d-flex justify-content-between align-items-start alert alert-danger">
                            <div className="vsalign">{error}</div>
                            <div className="vsalign">
                              <span
                                className=".h3 text-muted"
                                style={{ cursor: "pointer" }}
                                onClick={() => setError("")}
                              >
                                x
                              </span>
                            </div>
                          </div>
                        )}

                        {success && (
                          <div className="d-flex justify-content-between align-items-start alert alert-success">
                            <div className="vsalign">{success}</div>
                            <div className="vsalign">
                              <span
                                className=".h3 text-muted"
                                style={{ cursor: "pointer" }}
                                onClick={() => setSuccess("")}
                              >
                                x
                              </span>
                            </div>
                          </div>
                        )}

                        {show ? (
                          <>
                            <div className="form-group">
                              <input
                                type="number"
                                className="form-control form-control-lg"
                                placeholder="Enter Mobile Number"
                                name="number"
                                value={user.number}
                                readOnly={true}
                              />
                            </div>
                            <div className="form-group">
                              <input
                                type="text"
                                className="form-control form-control-lg"
                                placeholder="Enter OTP"
                                name="otp"
                                value={user.otp}
                                onChange={handleInput}
                              />
                              <p>Please check your WhatsApp notifications to get the OTP and continue.</p>
                            </div>

                            
                            <div className="mt-3">
                              <button
                                className="btn btn-block btn-primary btn-lg font-weight-medium auth-form-btn"
                                onClick={handleVerifyOTP}
                              >
                                VERIFY OTP
                              </button>
                            </div>
                          </>
                        ) : (
                          <>
                            <div className="form-group">
                              <input
                                type="text"
                                className="form-control form-control-lg"
                                placeholder="Enter Mobile Number"
                                maxLength={10}
                                name="number"
                                value={user.number}
                                onChange={handleInput}
                              />
                            </div>
                            <div className="mt-3">
                              <button
                                className="btn btn-block btn-primary btn-lg font-weight-medium auth-form-btn"
                                onClick={handleSendOTP}
                              >
                                SEND OTP
                              </button>
                            </div>
                          </>
                        )}

                        <div className="my-2 d-flex justify-content-between align-items-center">
                          <div className="form-check">
                            <Link to="/auth">
                              <span className="text-primary">Login</span>
                            </Link>
                          </div>
                          <Link to="/forgot_password">
                            <span className="auth-link text-black">
                              Forgot password?
                            </span>
                          </Link>
                        </div>
                        <div className="text-center mt-2 fw-light">
                          Don't have an account?{" "}
                          <Link to="/signup">
                            <span className="text-primary">Create</span>
                          </Link>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* <LiveChat /> */}
        </>
      )}
    </>
  );
};

export default LoginWithOTP;
